/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Katalog_Desi_Page_DisclaimerInputs */

const tr_katalog_desi_page_disclaimer = /** @type {(inputs: Katalog_Desi_Page_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desi-skalası kargo firmasına göre küçük farklılıklar gösterebilir; bu sayfa Yurtiçi/MNG standardı olan 3000 bölenini kullanır.`)
};

const en_katalog_desi_page_disclaimer = /** @type {(inputs: Katalog_Desi_Page_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The desi scale can vary slightly by carrier; this page uses the Yurtiçi/MNG standard divisor of 3000.`)
};

const de_katalog_desi_page_disclaimer = /** @type {(inputs: Katalog_Desi_Page_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Desi-Skala kann je nach Versanddienst leicht variieren; diese Seite nutzt den Yurtiçi/MNG-Standardteiler 3000.`)
};

const ru_katalog_desi_page_disclaimer = /** @type {(inputs: Katalog_Desi_Page_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Шкала деси может немного отличаться у разных перевозчиков; эта страница использует стандартный делитель Yurtiçi/MNG: 3000.`)
};

/**
* | output |
* | --- |
* | "The desi scale can vary slightly by carrier; this page uses the Yurtiçi/MNG standard divisor of 3000." |
*
* @param {Katalog_Desi_Page_DisclaimerInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const katalog_desi_page_disclaimer = /** @type {((inputs?: Katalog_Desi_Page_DisclaimerInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Katalog_Desi_Page_DisclaimerInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_katalog_desi_page_disclaimer(inputs)
	if (locale === "de") return de_katalog_desi_page_disclaimer(inputs)
	if (locale === "ru") return ru_katalog_desi_page_disclaimer(inputs)
	return tr_katalog_desi_page_disclaimer(inputs)
});